// import external dependencies
import 'jquery';
import Swiper from 'swiper'; // eslint-disable-line no-unused-vars
import Select2 from 'select2'; // eslint-disable-line no-unused-vars
import MaximizeSelect2Height from 'maximize-select2-height'; // eslint-disable-line no-unused-vars

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
/* eslint-disable */
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// import historyTimeline from './components/history';
import story from './components/story';
import infoGraphicsCircles from './components/info-graphics-circles';
import anchor from './components/anchor';
import expandable from './components/expandable';
import cover from './components/cover';
import accordion from './components/accordion';
import linkListing  from './components/link-listing';
import imageGallery  from './components/image-gallery';
import relatedArticles  from './components/related-articles';
import infoGraphics  from './components/info-graphics';
import gauges  from './components/gauges';
import productCollapse from './components/products/product-collapse';
import produkter from './components/products/products';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,

    // historyTimeline,
    story,
    infoGraphicsCircles,
    anchor,
    expandable,
    cover,
    accordion,
    linkListing,
    imageGallery,
    relatedArticles,
    infoGraphics,
    gauges,
    productCollapse,
    produkter
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js